import React from 'react'
import clsx from 'clsx'

export type LayoutRowProps = {
	className?: string
	children: React.ReactNode
}

const LayoutRow = ({ className, children }: LayoutRowProps) => {
	return <div className={clsx('mb-3', className)}>{children}</div>
}

export default LayoutRow
